import { computed } from 'vue'
import { useStore } from '../store/index'
import { obtenerPlantilla } from '../plantillas'

/**
 * Plantilla de la web actual (NOTARIA.Web.Plantilla) y el layout que le toca.
 * Para la plantilla de notaría el layout es undefined: <NuxtLayout> se comporta como siempre
 * (default, o el layout que declare la página, como 'blank' en encargo-qr).
 */
export function usePlantilla() {
  const store = useStore()
  const route = useRoute()
  const plantilla = computed(() => obtenerPlantilla(store.NOTARIA?.Web?.Plantilla))
  const layout = computed(() => {
    const propio = plantilla.value.layout
    if (!propio) return undefined
    return (route.meta.layout as string | undefined) ?? propio
  })
  return { plantilla, layout }
}
